import { PersonSummary } from './person.model';
import * as moment from 'moment';

export interface ITaxInfoContainer {
  taxInfo: TaxInfo[];
}
export class TaxInfo {
  taxInfoId: number | null = null;
  businessCategoryId: number | null = null;
  defaultHostId: number | null = null;
  defaultHost: PersonSummary | null = null;
  chargebackId: number | null = null;
  jobGradeId: number | null = null;
  employeeTypeId: number | null = null;
  isSpecified: boolean = false;
  neo: boolean = false;
  startDate: moment.Moment | string | null = null;
  endDate: moment.Moment | string | null = null;
}

export const isTaxInfoSaved = (obj: TaxInfo) => {
  return obj.taxInfoId && obj.taxInfoId > 0;
};
